export const salesWhatsappNumber = '97286222220';
export const supportWhatsappNumber = '972587370507';
